<template>
	<el-dialog title="选择产品" :visible.sync="visible" :before-close="beforClose" width="30%">
		<div>
			<el-form :inline="true">
				<el-form-item label="产品搜索">
					<el-input v-model="queryKey" placeholder="按名称进行产品搜索">
						<i slot="prefix" class="el-input__icon el-icon-search"></i>
					</el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="query">查询</el-button>
				</el-form-item>
			</el-form>
		</div>
		<el-table border :data="data" size="small" v-loading="loading" style="width:100%;">
			<el-table-column type="index" label="序号" width="80"></el-table-column>
			<el-table-column prop="name" label="产品名称"></el-table-column>
			<el-table-column label="操作" width="120">
				<template slot-scope="scope">
					<el-link @click="select(scope.row)" icon="el-icon-edit">选择</el-link>
				</template>
			</el-table-column>
		</el-table>

		<!--分页-->
		<el-pagination layout="prev, pager, next" :page-size="pageSize" :page-count="pageCount" v-on:current-change="currentChange"> </el-pagination>
	</el-dialog>
</template>

<script>
	import * as productRequest from '@/network/requests/product'
	export default {
		props: {
			show: {
				type: Boolean,
			},
		},
		data() {
			return {
				data: [],
				pageCount: 0,
				visible: false,
				queryKey: '',
				pageSize: 10,
				pageIndex: 1,
				filterUpdated: [0, 1],
				loading: false,
			}
		},
		watch: {
			show(val) {
				this.visible = val
				if (val) {
					this.query()
				}
			},
			pageIndex(val) {
				this.query()
			},
		},
		methods: {
			/**
			 * 关闭
			 */
			beforClose(done) {
				this.$emit('close')
				done()
			},
			/**
			 * 查询产品。
			 */
			query() {
				this.loading = true
				console.log(this.queryKey)
				productRequest
					.queryProduct(this.pageSize, this.pageIndex, {
						name: this.queryKey,
						updated: this.filterUpdated,
					})
					.then(({data}) => {
						this.data = data._embedded
						this.loading = false
						this.pageCount = data._total_pages
					})
			},
			/**
			 * 选择产品。
			 */
			select(row) {
				this.$emit('select', {
					id: row._id.$oid,
					name: row.name,
				})
			},
			/**
			 * 切换页码。
			 */
			currentChange(pageIndex) {
				this.pageIndex = pageIndex
			},
		},
		created() {},
	}
</script>

<style></style>
